import { Referential } from '@/features/shared/types';

export enum REGISTER_SUBSCRIBE_ADDITIONNAL_INFORMATIONFORM_FORM {
  invoicingEmail = 'invoicingEmail',
  weeklyDispatchVolume = 'weeklyDispatchVolume',
  registrationNumber = 'registrationNumber',
  paymentMethodId = 'paymentMethodId',
  companyTypeId = 'companyTypeId',
  holderName = 'holderName',
  vatNumber = 'vatNumber',
  bankName = 'bankName',
  kbisFile = 'kbisFile',
  eori = 'eori',
  iban = 'iban',
  bic = 'bic',
}

export type RegisterSubscribeAdditionnalInformationForm = {
  invoicingEmail: string;
  weeklyDispatchVolume: string;
  registrationNumber: string;
  paymentMethodId: string;
  companyTypeId: string;
  holderName: string;
  vatNumber: boolean;
  bankName: string;
  kbisFile: File;
  eori: string;
  iban: string;
  bic: string;
};

export type GetCompanyTypeReferential = {
  companyTypes: Referential[];
};

export type GetPaymentMethodsReferential = {
  paymentMethods: Referential[];
};
